import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { Timecode } from '../shared';
/**
 * The maximum number of audio tracks that can exist in a recording. TRMs currently
 * limit this to eight tracks.
 */
export const MAX_AUDIO_TRACKS_PER_RECORDING = 32;
/**
 * Represents a chunk of audio (e.g. a single TRM) which contains multiple tracks.
 */
export class MultiTrackAudioChunk {
    /**
     * @param contentType A MIME type describing the content of the audio tracks
     * @param timecode The period during which this audio chunk was recorded
     * @param tracks Audio objects containing the multiple tracks
     */
    constructor(contentType, timecode, tracks) {
        this.contentType = contentType;
        this.tracks = tracks;
        this.timecode = timecode;
    }
}
__decorate([
    Type(() => Timecode),
    __metadata("design:type", Timecode
    /**
     * @param contentType A MIME type describing the content of the audio tracks
     * @param timecode The period during which this audio chunk was recorded
     * @param tracks Audio objects containing the multiple tracks
     */
    )
], MultiTrackAudioChunk.prototype, "timecode", void 0);
